export default __webpack_public_path__ + "static/media/social.8b2ecf49.png";